export default __webpack_public_path__ + "static/media/headline.afaa9bbd.png";